import { PiniaColada } from "@pinia/colada";
import { createPinia } from "pinia";
import { createApp } from "vue";

import { initPrimeVue } from "@solvari/components";
import { getEnv, getSentry } from "@solvari/utils";

import { getRootElement } from "@/helpers/rootElement";

import App from "./App.vue";

type Dataset = {
  affiliateId?: number | undefined;
  campaignId?: number | undefined;
  iframeId?: number | undefined;
};

function datasetToProps(rootElement: HTMLElement): Dataset {
  const dataset = rootElement.dataset;

  return dataset.props ? (JSON.parse(dataset.props) as Dataset) : {};
}

function main() {
  if (
    !["be-NL", "be-FR", "nl-NL", "se-SV", "dk-DA"].includes(
      getEnv().config.localeCode,
    )
  ) {
    throw new Error(
      'Company registration form only supports "be-NL", "be-FR", "nl-NL", "se-SV", "dk-DA"',
    );
  }

  const rootElement = getRootElement();

  const app = createApp(App, { ...datasetToProps(rootElement) });
  getSentry().trackVueErrors(app);

  app.use(createPinia());
  app.use(PiniaColada, {});
  initPrimeVue(app);

  app.mount(rootElement);
}

main();
